import { state, emitChange } from "../../state/store.js";
import { phoneFromChatJid, sortChatsForList } from "../../views/Chat.helpers.ts";

export function applyChatPatch(patchObj) {
  const idx = state.chats.findIndex((chat) => chat.chatJid === patchObj.chatJid);
  if (idx < 0) return;
  const merged = { ...state.chats[idx] };
  for (const key of ["pushName", "subject", "phone", "isGroup", "leadId", "unreadCount", "archived"]) {
    if (patchObj[key] !== undefined && patchObj[key] !== null && patchObj[key] !== "") {
      merged[key] = patchObj[key];
    }
  }
  if (patchObj.pinnedAt !== undefined) merged.pinnedAt = patchObj.pinnedAt;

  const next = [...state.chats];
  next[idx] = merged;
  state.chats = patchObj.pinnedAt !== undefined ? sortChatsForList(next) : next;
  emitChange();
}

export function applyChatTags({ chatJid, added, removed }) {
  const idx = state.chats.findIndex((chat) => chat.chatJid === chatJid);
  if (idx < 0) return;
  const next = [...state.chats];
  const tagIds = new Set(next[idx].tagIds || []);
  if (added) tagIds.add(added);
  if (removed) tagIds.delete(removed);
  next[idx] = { ...next[idx], tagIds: Array.from(tagIds) };
  state.chats = next;
  emitChange();
}

export function bumpChatPreview(message) {
  const idx = state.chats.findIndex((chat) => chat.chatJid === message.chatJid);
  const isGroup = message.chatJid.endsWith("@g.us");
  const isLid = message.chatJid.endsWith("@lid");
  const inferredName = !message.fromMe && message.senderName ? message.senderName : "";
  const inferredPhone = isGroup || isLid ? "" : phoneFromChatJid(message.chatJid);
  const base = idx >= 0
    ? state.chats[idx]
    : {
        chatJid: message.chatJid,
        isGroup,
        pushName: inferredName,
        phone: inferredPhone,
      };
  const pushName = idx >= 0 ? (inferredName || base.pushName || "") : inferredName;
  const nextChat = {
    ...base,
    pushName,
    lastMsgId: message.messageKey,
    lastText: (message.text || "").slice(0, 500),
    lastKind: message.kind,
    lastFromMe: !!message.fromMe,
    lastStatus: message.status ?? base.lastStatus,
    lastTsMs: message.tsMs || base.lastTsMs || Date.now(),
    unreadCount: (message.fromMe || state.activeChatJid === message.chatJid || message.isHistory)
      ? (idx >= 0 ? base.unreadCount || 0 : 0)
      : ((idx >= 0 ? base.unreadCount || 0 : 0) + 1),
    leadId: message.leadId || base.leadId || null,
  };
  const others = state.chats.filter((chat) => chat.chatJid !== message.chatJid);
  state.chats = sortChatsForList([nextChat, ...others]);
}
